import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'react-select';
import { Input, InputGroup, InputGroupText, Modal, ModalBody, ModalHeader, Row, Col, Card, CardBody, Spinner, Button } from 'reactstrap';

import { ADD_SUGGEST_GOLF, GET_REASON_BY_ACTIONS, SUGGEST_GOLF } from '../../../../../../../store/actions';
import { Error } from '../../../../../../Common';
import { IoMdSearch } from 'react-icons/io';
import cogoToast from 'cogo-toast';
import { set } from 'lodash';

const SuggestCourse = ({ onClose, currentSelectedBooking, setIsShowModifyOptions }) => {
  const dispatch = useDispatch();

  const [selectedRemark, setSelectedRemark] = useState(null);
  const [isShowError, setIsShowError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedGolfCourse, setSelectedGolfCourse] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  const wrapperRef = useRef(null);

  const { remarksList, suggestGolf, addSuggestGolf, addSuggestGolfLoading, suggestGolfLoading } = useSelector(state => ({
    remarksList: state?.GetReasonByActions?.data,

    suggestGolf: state?.SuggestGolf?.data?.data,
    suggestGolfLoading: state?.SuggestGolf?.loading,

    addSuggestGolf: state?.AddSuggestGolf?.data,
    addSuggestGolfLoading: state?.AddSuggestGolf?.loading,
  }));

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (addSuggestGolf) {
      onClose();
      setIsShowModifyOptions(false);
    }
  }, [addSuggestGolf]);

  useEffect(() => {
    if (suggestGolf !== null) {
      setSuggestions(suggestGolf?.facility || []);
    }
  }, [suggestGolf]);

  useEffect(() => {
    dispatch({
      type: GET_REASON_BY_ACTIONS,
      payload: {
        urlParams: {
          booking_type: currentSelectedBooking?.bookingType || '',
          booking_status: currentSelectedBooking?.bookingStatus,
          action: 'suggest_new_golf_course',
          is_active: true,
        },
      },
    });
    suggestGolfCourse('');
  }, [currentSelectedBooking]);

  const suggestGolfCourse = name => {
    dispatch({
      type: SUGGEST_GOLF,
      payload: {
        params: {
          bookingId: currentSelectedBooking?.id || '',
          name: name,
        },
      },
    });
  };

  const inputSelectHandler = (label, data) => {
    if (label === 'reason_id') {
      setSelectedRemark(data);
    } else {
      setIsShowError(false);
    }
  };

  const addGolfCourse = course => {
    if (selectedGolfCourse.some(item => item.id === course.id)) {
      cogoToast.error('This golf course is already selected.');
    } else if (selectedGolfCourse.length >= 3) {
      cogoToast.error('You can only select up to 3 golf courses.');
      return;
    } else {
      setSelectedGolfCourse([...selectedGolfCourse, course]);
      setIsOpen(false);
    }
  };

  const removeGolfCourse = courseId => {
    setSelectedGolfCourse(selectedGolfCourse.filter(course => course.id !== courseId));
  };

  const searchGolf = name => {
    suggestGolfCourse(name);
  };

  const handleSubmit = () => {
    if (!selectedRemark || selectedGolfCourse?.length === 0) {
      setIsShowError(true);
      return;
    }

    const payload = {
      booking_id: currentSelectedBooking?.id,
      reason_id: selectedRemark?.value,
      facilities: selectedGolfCourse.map(course => {
        return {
          id: course.id,
          name: course.name,
          service_id: course.service_id,
          confidence_score: course.confidence_score,
          addon: course.addon || {},
          distance: course?.distance,
        };
      }),
    };

    dispatch({
      type: ADD_SUGGEST_GOLF,
      payload: {
        body: payload,
      },
    });
  };

  return (
    <Modal isOpen={true} centered toggle={onClose}>
      <ModalHeader toggle={onClose}>
        <h4>Suggest New Course</h4>
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md={12} className="mb-3">
            <Select
              id="decline-remarks"
              name="decline-remarks"
              placeholder="Select reason for golf booking"
              value={selectedRemark}
              options={remarksList?.reasons?.map(remark => ({
                label: remark?.reason,
                value: remark?.id,
              }))}
              onChange={data => inputSelectHandler('reason_id', data)}
            />
            {isShowError && selectedRemark === null && <Error text="Kindly select reason for declining" ref={null} />}
          </Col>
        </Row>

        {/* Wrap the trigger + card in a ref */}
        <div ref={wrapperRef}>
          <Row>
            <Col md={12} className="mb-3">
              <Select
                id="suggest-golf-course"
                name="suggest-golf-course"
                placeholder="Suggest New Golf Course"
                isSearchable={false}
                hideSelectedOptions={true}
                menuIsOpen={false}
                onFocus={() => {
                  if (selectedGolfCourse.length >= 3) {
                    cogoToast.error('You can only select up to 3 golf courses.');
                    return;
                  }
                  setIsOpen(!isOpen);
                }}
                isDisabled={selectedGolfCourse.length >= 3}
              />
            </Col>
          </Row>

          <div className="d-flex gap-2 flex-wrap">
            {selectedGolfCourse.map((item, index) => (
              <div
                key={index}
                style={{
                  color: item.color,
                  padding: '2px 6px',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 500,
                  border: `1px solid ${item.color}`,
                  cursor: 'pointer',
                }}
              >
                <span>
                  {item.name} - <strong style={{ fontSize: '9px' }}>{item.confidence_score}%</strong>
                </span>
                <span
                  style={{
                    marginLeft: '8px',
                    cursor: 'pointer',
                    fontWeight: 700,
                  }}
                  onClick={() => removeGolfCourse(item.id)}
                >
                  ×
                </span>
              </div>
            ))}
          </div>

          {isOpen && (
            <Card
              style={{
                position: 'absolute',
                top: '52%',
                left: '4%',
                width: '85%',
                zIndex: 1000,
              }}
            >
              <InputGroup
                style={{
                  width: '315px',
                  margin: '15px',
                  borderRadius: '20px',
                  overflow: 'hidden',
                }}
              >
                <InputGroupText
                  style={{
                    background: 'transparent',
                    borderRight: 'none',
                    borderRadius: '20px 0 0 20px',
                  }}
                >
                  <IoMdSearch size={20} />
                </InputGroupText>
                <Input
                  type="text"
                  placeholder="Search Golf Course..."
                  style={{
                    borderRadius: '0 20px 20px 0',
                    borderLeft: 'none',
                  }}
                  onChange={e => {
                    const value = e.target.value;
                    searchGolf(value);
                  }}
                />
              </InputGroup>
              {!suggestGolfLoading ? (
                <CardBody style={{ maxHeight: '300px', overflowY: 'auto', padding: '0' }}>
                  {suggestions?.length > 0 &&
                    suggestions.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center px-3 py-3 border-bottom cursor-pointer"
                        onClick={() => addGolfCourse(item)}
                      >
                        <strong>{item.name}</strong>
                        <span>
                          Confidence Score:{' '}
                          <span style={{ color: item.color }} className="fw-semibold">
                            {' '}
                            {item.confidence_score}%
                          </span>{' '}
                        </span>
                      </div>
                    ))}
                  {suggestions?.length === 0 && (
                    <div className="text-center py-3">
                      <strong>No suggestions found</strong>
                    </div>
                  )}
                </CardBody>
              ) : (
                suggestGolfLoading && <Spinner className="btn-replacer-spinner m-auto" />
              )}
            </Card>
          )}
        </div>

        <Col md={12} className="mt-3 mb-4 text-center">
          {addSuggestGolfLoading ? (
            <Button color="primary" style={{ fontSize: '14px', width: '200px' }}>
              <Spinner className="btn-replacer-spinner" />
            </Button>
          ) : (
            <Button color="primary" style={{ fontSize: '14px', width: '200px' }} onClick={handleSubmit}>
              Suggest Golf Course
            </Button>
          )}
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default SuggestCourse;
